export default "__VITE_ASSET__C_cIo3_s__"